export {default} from './PerformanceTab.connect';
